module.exports = __webpack_public_path__ + "img/programasInst.7d4c32c8.jpg";